import "./style/Coaches.css";

// import {FiEdit} from "react-icons/fi";
// import {AiOutlineDelete} from "react-icons/ai";
import { useEffect, useState } from "react";
import {
  getAllTransactions,
  getTotalTrans,
  getTransactionsCount,
} from "../apicalls/transaction";
import { isAuthenticated } from "../apicalls/auth";
import Paginations from "./Paginations";
import NumberFormat from "react-number-format";
import debounce from "lodash.debounce";

function Transaction() {
  const [temp, setTemp] = useState([]);

  const [transactions, setTransactions] = useState([]);
  const [search, setSearch] = useState("");
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [PerPage, setPostPerPage] = useState(10);

  const user = isAuthenticated();
  const accessToken = user?.access_token;

  useEffect(() => {
    if (!accessToken) {
      return;
    }

    getAllTransactions(accessToken, PerPage, currentPage, search).then(
      (data) => {
        console.log(data);
        setTransactions(data);
      }
    );

    // Counts card payments and pay-on-court lessons, matching the list. Falls back to the
    // card-only count if the API doesn't have the count endpoint yet.
    getTransactionsCount(accessToken, search)
      .then((data) =>
        typeof data?.total === "number"
          ? data.total
          : getTotalTrans(accessToken).then((cards) => cards?.length || 0)
      )
      .then((count) => {
        setTotal(count);
        let temp2 = [];
        for (let i = currentPage; i <= Math.ceil(count / 10); i++) {
          temp2.push(i * 10);
        }
        setTemp(temp2);
      });
  }, [search, currentPage, PerPage, accessToken]);

  const handleChange = (e) => {
    setPostPerPage(e.target.value);
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const deBounceOnChange = debounce(handleSearch, 500);

  const paginate = (number) => {
    setCurrentPage(number);
  };

  return (
    <main>
      <div className="coaches_title">
        <h1>Transaction</h1>
      </div>
      <div className="filter">
        {currentPage > 1 ? (
          ""
        ) : (
          <div>
            <select name="" id="" onChange={handleChange}>
              {temp.map((val) => {
                return (
                  <option key={val} value={val}>
                    {val}
                  </option>
                );
              })}
            </select>
            <span>
              show {PerPage} out of {total}
            </span>
          </div>
        )}
        <input
          className="w-25"
          type="text"
          onChange={deBounceOnChange}
          placeholder="Search"
        />
      </div>

      <div className="col-11">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Player Name</th>
                <th scope="col">Date</th>
                <th scope="col">Amount</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              {transactions?.length > 0 ? (
                transactions.map((trans) => {
                  const payOnCourt = trans.kind === "pay_on_court";
                  return (
                    <tr key={trans.row_id || trans.id}>
                      <td className="fw-bold d-flex">
                        <span>
                          <img
                            src={trans.profile_picture}
                            alt=""
                            id="table_img"
                          />
                        </span>
                        <span>
                          <span>
                            {trans.full_name}
                            {payOnCourt ? (
                              <span className="pay-on-court-tag">Pay on court</span>
                            ) : null}
                            <span className="text-danger fw-normal">
                              {trans.is_deleted ? " ( player deleted )" : ""}
                            </span>
                          </span>
                          <span style={{ fontSize: "13px" }}>
                            ({new Date(trans.start_date_time).toLocaleString()}{" "}
                            to {new Date(trans.end_date_time).toLocaleString()},{" "}
                            {trans.location})
                          </span>
                        </span>
                      </td>
                      <td>
                        {new Date(trans.transaction_date_time).toLocaleString()}
                      </td>
                      <td className="fw-bold">
                        {trans.amount === null || trans.amount === undefined ? (
                          "—"
                        ) : (
                          <NumberFormat
                            value={trans.amount / 100}
                            prefix={"$"}
                            displayType={"text"}
                            thousandSeparator={true}
                          ></NumberFormat>
                        )}
                        {trans.amount_estimated && trans.amount !== null ? (
                          <span
                            className="fw-normal text-muted"
                            style={{ fontSize: "13px" }}
                            title="Confirmed before prices were recorded: estimated from the coach's current rate"
                          >
                            {" "}
                            est.
                          </span>
                        ) : null}
                        {payOnCourt ? (
                          <div className="fw-normal text-muted" style={{ fontSize: "12px" }}>
                            paid to coach at court
                          </div>
                        ) : null}
                      </td>
                      <td
                        className={
                          trans.payment_status === "Success" ||
                          trans.payment_status === "Collected"
                            ? "success fw-bold"
                            : payOnCourt
                            ? "pending fw-bold"
                            : "error fw-bold"
                        }
                      >
                        {trans.payment_status}{" "}
                        {trans.is_refund ? (
                          <span className="error" style={{ fontSize: "13px" }}>
                            (refunded)
                          </span>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td>
                    <h2>Transaction not Available</h2>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {search ? (
          " "
        ) : (
          <Paginations
            perPage={PerPage}
            total={total}
            paginate={paginate}
            currentPage={currentPage}
          />
        )}
      </div>
    </main>
  );
}

export default Transaction;
